module.exports = __webpack_public_path__ + "static/media/snake.5e77e64e.m4a";